var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrantsHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32.5,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.4858,
    r: 40,
    fill: "#8C65F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.4863,
    r: 22,
    fill: "url(#paint0_radial_130_440)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.4854,
    r: 14,
    transform: "rotate(-180 40 40.4854)",
    fill: "#F5DA59"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9998,
    cy: 8.98698,
    r: 2.66667,
    fill: "#F5DA59"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.4985,
    cy: 40.486,
    r: 2.66667,
    transform: "rotate(90 71.4985 40.486)",
    fill: "#F5DA59"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.50106,
    cy: 40.486,
    r: 2.66667,
    transform: "rotate(90 8.50106 40.486)",
    fill: "#F5DA59"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2786,
    cy: 56.2353,
    r: 2.66667,
    transform: "rotate(120 67.2786 56.2353)",
    fill: "#F5DA59"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7212,
    cy: 24.7368,
    r: 2.66667,
    transform: "rotate(120 12.7212 24.7368)",
    fill: "#F5DA59"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2789,
    cy: 24.7365,
    r: 2.66667,
    transform: "rotate(60 67.2789 24.7365)",
    fill: "#F5DA59"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7214,
    cy: 56.236,
    r: 2.66667,
    transform: "rotate(60 12.7214 56.236)",
    fill: "#F5DA59"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7494,
    cy: 13.2082,
    r: 2.66667,
    transform: "rotate(30 55.7494 13.2082)",
    fill: "#F5DA59"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2507,
    cy: 67.7643,
    r: 2.66667,
    transform: "rotate(30 24.2507 67.7643)",
    fill: "#F5DA59"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7487,
    cy: 67.7642,
    r: 2.66667,
    transform: "rotate(150 55.7487 67.7642)",
    fill: "#F5DA59"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2501,
    cy: 13.2075,
    r: 2.66667,
    transform: "rotate(150 24.2501 13.2075)",
    fill: "#F5DA59"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7487,
    cy: 67.7642,
    r: 2.66667,
    transform: "rotate(150 55.7487 67.7642)",
    fill: "#F5DA59"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2501,
    cy: 13.2075,
    r: 2.66667,
    transform: "rotate(150 24.2501 13.2075)",
    fill: "#F5DA59"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9998,
    cy: 71.985,
    r: 2.66667,
    fill: "#F5DA59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_130_440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40.4863) rotate(90) scale(22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02E2AC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantsHubLogo);
export default __webpack_public_path__ + "static/media/grants-hub-logo.608437fa6f5609ba2d612fe0a06aa895.svg";
export { ForwardRef as ReactComponent };